import styled from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { Typography } from '@/components/Typography';

export const Wrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  opacity: 0.15;
`;

export const Line = styled(Box)`
  flex-grow: 1;
  height: 1px;
  background: ${({ theme }) => theme.colors.black};
`;

export const Text = styled(Typography)`
  margin: 0 10px;
  font-size: ${({ theme }) => theme.fontSizes.p2};
`;
